<template>
  <div>
    <!-- <header>
      <Header msg="Header" />
      <header>
        <div class="selectbar">
          <div class="container">
            <select name="status-filter" v-model="statusFilter" @change="onStatusFilterChange($event)" >
              <option selected value="all">全部</option>
              <option value="notpay">未付款</option>
              <option value="new">未接單</option>
              <option value="confirmed">已接單</option>
              <option value="cancelled">已取消</option>
            </select>
          </div>
        </div>
      </header>
    </header> -->
    <main>
      <nav class="tabs order">
        <div class="container">
          <!--<a v-if="showRetail"
            href="javascript:"
            v-on:click="selectedCategory = 'retail'; cacheSelectedCategory('retail');"
            :class="[selectedCategory === 'retail' ? 'current': '']"
          >零售訂單</a>-->
          <!--<a
            href="javascript:"
            v-on:click="selectedCategory = 'history'; cacheSelectedCategory('history');"
            :class="[selectedCategory === 'history' ? 'current': '']"
          >過去訂單紀錄</a>-->
          <!--<a
            href="javascript:"
            v-on:click="selectedCategory = 'new'; cacheSelectedCategory('new');"
            :class="[selectedCategory === 'new' ? 'current': '']"
          >新訂單</a>-->
        </div>
      </nav>

      <div v-if="loading" class="loading_area flex_center">
        <div class="loader"></div>
        <div>loading..</div>
      </div>

      <div
        v-if="
          !orders ||
            !orders[selectedCategory] ||
            !orders[selectedCategory].length
        "
        class="page_notfound container flex_center flex_wrap"
      >
        <section>
          <div class="icon-notfound"></div>
          <div>
            <b></b>
          </div>
          <div>您沒有{{ categoryName[selectedCategory] }}</div>
        </section>
      </div>
      <div class="storelist image_s order container flex_top flex_wrap">
        <a
          v-for="(order, index) in orders[selectedCategory]"
          :key="index"
          class="flex_center flex_wrap"
          v-on:click="goToOrder(order.orderId)"
        >
          <!--<div class="cover">
            <img :src="order.profileImageUrl || defaultImage" />
          </div>-->

          <div v-if="!order.orderStatus" class="pick_number none">
            訂單<br />尚未成立
          </div>
          <div
            v-if="order.orderStatus && order.shopCategory !== 'retail' && order.partnerOrderId"
            :class="[
              'pick_number',
              mealTypeColor[order.mealType]
            ]"
          >
            {{mealTypeMap[order.mealType]}}
          </div>
           <div
            v-else-if="order.orderStatus && order.shopCategory !== 'retail'"
            :class="[
              'pick_number',
              mealTypeColor[order.mealType]
            ]"
          >
            取餐編號<b>{{ order.no }}</b>
          </div>
          <div
            v-else-if="order.orderStatus"
            :class="[
              'pick_number',
              mealTypeColor[order.mealType]
            ]"
          >
            {{ mealTypeMap[order.mealType] }}<b>{{ order.no }}</b>
          </div>
          <!-- <div :class="['pick_number', mealTypeColor[order.mealType]]">{{mealTypeMap[order.mealType]}}<b>{{order.no}}</b></div> -->
          <!-- <div class="pick_number self">自取<b>1</b></div>
			<div class="pick_number inside">內用<b>1</b></div>
			<div class="pick_number freight">宅配<b>1</b></div> -->
          <div class="info">
            <div class="name">{{ order.shopName }}</div>
            <div v-if="order.shopCategory === 'retail'" class="order">
              訂單編號 {{ order.orderId }}
              <span v-if="!order.orderStatus">
                付款完成後將成立訂單
              </span>
            </div>
            <div v-else class="order">
              <span v-if="order.orderStatus">
                訂單編號 {{ order.orderId }}
                <br />
                取餐時間 {{ order.takeMealTime }}
              </span>
              <span v-else>
                訂單編號 {{ order.orderId }}
                <br />
                付款完成後將成立訂單
              </span>
            </div>
          </div>
          <div class="focus">
            <div class="price">
              $
              <b>{{ order.orderAmount }}</b>
            </div>
            <div class="status finished">{{ sLabel[order.orderStatus] }}</div>
            <!-- <button v-if="!sLabel[order.orderStatus] && !order.isPaymentTimeout" type="button" onclick="window.open('#')">前往付款</button> -->
            <div
              v-if="!sLabel[order.orderStatus] && !order.isPaymentTimeout"
              class="status waiting"
            >
              等待付款
            </div>
            <div
              class="status finished"
              v-if="!sLabel[order.orderStatus] && order.isPaymentTimeout"
            >
              未完成付款
            </div>
          </div>
          <div class="iconbar">
            <!-- <div v-if="order.groupCount" class="groupbuy">
              <i class="icon-groupbuy"></i>揪團一起點
            </div> -->
            <div class="pick">
              <i :class="[mealTypeIcon[order.mealType]]">{{
                mealMap[order.mealType]
              }}</i>
              <!-- <i class="icon_self">自</i>
              <i class="icon_inside">內</i>-->
            </div>
            <div class="pay">
              <i :class="payTypeIcon[order.paymentType]"></i>
            </div>
          </div>
        </a>
      </div>
      <!-- END .storelist.image_s.order -->
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import moment from "moment";
import apis from "@/services/apis";
import { authService } from "@/services/auth";

// 被選中的要增加class current
export default {
  name: "Footer",
  props: ["type"],
  data() {
    return {
      showRetail: false,
      loading: false,
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      statusFilter: "all", // all, notpay, new, accepted
      selectedCategory: "new",
      categoryName: {
        new: "新訂單",
        history: "過去訂單紀錄",
      },
      orders: {
        new: [],
        history: [],
      },
      mealMap: {
        eat_in: "內",
        to_go: "自",
        delivery: "送",
        shipping: "宅",
        direct: "院內送",
      },
      mealTypeMap: {
        eat_in: "內用",
        to_go: "自取",
        delivery: "外送",
        shipping: "宅配",
        direct: "院內送",
      },
      mealTypeColor: {
        eat_in: "inside",
        delivery: "delivery",
        to_go: "self",
        shipping: "freight",
        direct: "hospital",
      },
      mealTypeIcon: {
        eat_in: "icon_inside",
        to_go: "icon_self",
        delivery: "icon_delivery",
        shipping: "icon_freight",
        direct: "icon_hospital",
      },
      payTypeIcon: {
        cash: "icon_cash",
        qrpay_credit: "icon_creditcard",
        qrpay_google: "icon_googlepay",
        qrpay_line: "icon_linepay",
        qrpay_apple: "icon_applepay",
        qrpay_easywallet: "icon_easywallet",
        qrpay_icashpay: "icon_icash",
        qrpay_pxpay: "icon_pxpay",
        qrpay_pxpayplus: "icon_pxpay",
        qrpay_pluspay: "icon_pluspay",
        apple: "icon_applepay",
        samsung: "icon_creditcard",
        multiple: "icon_creditcard",
        line: "icon_linepay",
        google: "icon_googlepay",
        easywallet: "icon_easywallet",
        taiwanpay: "icon_taiwanpay",
        jkopay: "icon_jkopay",
        pxpay: "icon_pxpay",
        pxpayplus: "icon_pxpay",
        icashpay: "icon_icash",
        pluspay: "icon_pluspay",
        twqr: "icon_twqr",
        yuanta: "icon_twqr",
        qrpay_twqr: "icon_twqr",
        qrpay_yuanta: "icon_twqr",
        aftee: "icon_aftee",
        qrpay_aftee: "icon_aftee",
      },
      payMap: {
        cash: "現金",
        qrpay_credit: "信用卡",
        qrpay_google: "Google Pay",
        qrpay_line: "LINE Pay",
        qrpay_apple: "Apple Pay",
        apple: "Apple Pay",
        samsung: "Samsung Pay",
        multiple: "行動支付",
        line: "LINE Pay",
        google: "Google Pay",
        taiwanpay: "台灣Pay",
        jkopay: "街口Pay",
        easywallet: "悠遊付",
        pxpay: "全支付",
        pxpayplus: "全支付",
        icashpay: "icash Pay",
        pluspay: "全盈支付",
        twqr: "TWQR",
        yuanta: "TWQR",
        qrpay_twqr: "TWQR",
        qrpay_yuanta: "TWQR",
        aftee: "Aftee",
        qrpay_aftee: "Aftee",
      },
      label: {
        new: "商家正在確認訂單",
        accepted: "店家已接收訂單",
        done: "餐點完成",
        rejected: "訂單已取消",
        cancelled: "訂單已取消",
        lala_assigning_driver: "媒合司機中",
        lala_on_going: "司機取餐中",
        lala_picked_up: "司機送餐中",
        lala_completed: "成功送達",
        lala_rejected: "司機取消物流",
        lala_expired: "物流逾期",
        lala_cancelled: "媒合司機中",
        lala_customer_service: "物流處理中",
      },
      sLabel: {
        new: "已下單",
        accepted: "已接單",
        done: "已完成",
        rejected: "已取消",
        cancelled: "已取消",
        lala_assigning_driver: "媒合司機",
        lala_on_going: "司機取餐",
        lala_picked_up: "司機送餐",
        lala_completed: "成功送達",
        lala_rejected: "物流取消",
        lala_expired: "物流逾期",
        lala_cancelled: "媒合司機",
        lala_customer_service: "物流處理",
      },
    };
  },
  computed: {
    userId() {
      let userId = localStorage.getItem("lineUserId");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      if (userProfile) {
        let userProfileObj = JSON.parse(Base64.decode(userProfile));
        // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
        // console.log('vs ' + GLOBAL_ENV_LIFFID);
        if (
          !userProfileObj.liffApp ||
          userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
        ) {
          userId = userProfile = null;
        }
      }
      return userId;
      // return localStorage.getItem("lineUserId");
    },
    uuid() {
      
      let uuid = localStorage.getItem("qcsso:uuid");
      // console.log('compute the uuid ' + uuid);
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      if (userProfile) {
        let userProfileObj = JSON.parse(Base64.decode(userProfile));
        // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
        // console.log('vs ' + GLOBAL_ENV_LIFFID);
        if (
          !userProfileObj.liffApp ||
          userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
        ) {
          uuid = userProfile = null;
        }
      }
      return uuid;
      // return localStorage.getItem("lineUserId");
    },
  },
  components: {
    Header,
  },
  methods: {
    onStatusFilterChange(event) {
      // if (this.$router.currentRoute.query.a === "sso") {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        let byUuid = true;
        this.getOrders(this.uuid, byUuid);
      } else {
        this.getOrders(this.userId);
      }
    },
    cacheSelectedCategory(category) {
      localStorage.setItem("orderCategory", category);
    },
    goToOrder(orderId) {
      // console.log('check the type' + this.type);
      let path = '/orders/';
      if (this.type === 'web') {
        path = '/web-orders/'
      }
      this.$router.push({
        path: path + orderId,
        query: this.$router.currentRoute.query,
      });
    },
    getOrders(userId, byUuid) {
      let self = this;

      self.loading = true;

      // console.log(
      //   "the by uudi and query " +
      //     byUuid +
      //     " " +
      //     self.$router.currentRoute.query.a
      // );
      let queryApi = apis.getPortalOrders;
      if (byUuid) queryApi = apis.getPortalOrdersByUuid;

      queryApi(
        userId,
        self.$router.currentRoute.query.p,
        self.$router.currentRoute.query.s,
        self.statusFilter
      )
        .then(function(responses) {
          // console.log("the response " + JSON.stringify(responses));
          
          self.orders.new = [];
          self.orders.history = [];
          self.orders.retail = [];

          for (let i = 0; i < responses.length; ++i) {
            responses[i].createdTime = moment
              .unix(responses[i].createdTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
            responses[i].takeMealTime = moment
              .unix(responses[i].takeMealTs)
              .format("YYYY-MM-DD HH:mm:ss Z");

            responses[i].isPaymentTimeout =
              moment().diff(moment.unix(responses[i].createdTs), "minutes") < 10
                ? false
                : true;
            // responses[
            //   i
            // ].link = `./me/orders?shop_id=${responses[i].shopId}&order_id=${responses[i].orderId}`;

            responses[
              i
            ].link = `./orders/${responses[i].orderId}?p=${self.$router.currentRoute.query.p}`;
          }

          for (let i = 0; i < responses.length; ++i) {
            if (responses[i].shopCategory === "retail") {
              // 零售版本
              switch (responses[i].mealType) {
                case "delivery":
                  responses[i].mealType = "shipping";
                  break;
                case "to_go":
                  responses[i].mealType = "direct"; //暫時先顯示宅配
                  break;
                case "eat_in":
                  responses[i].mealType = "to_go"; // 零售的自取存到DB是eat_in...
                  break;
              }
              // // if (self.showRetail) {
              // //   self.orders.retail.push(responses[i]);
              // // } else {
              //   if (responses[i].isCancelled ) { // 取消直接歸到歷史訂單
              self.orders.history.push(responses[i]);
              //   } else {
              //     self.orders.new.push(responses[i]);
              //   }
              // // }
            } else {
              // let check = moment().diff(
              //   moment.unix(responses[i].takeMealTs),
              //   "hours"
              // );

              // if (check > 0 || responses[i].isCancelled ) { // 取消直接歸到歷史訂單
              self.orders.history.push(responses[i]);
              // } else {
              //   self.orders.new.push(responses[i]);
              // }
            }
          }
          // console.log("the order debug " + JSON.stringify(self.orders));
          // console.log("the response is " + JSON.stringify(responses));
          self.loading = false;
        })
        .catch(function(e) {
          console.log(e.stack);
          self.loading = false;
        });
    },
  },
  mounted() {
    console.log('the props checking ' + this.type);
    // console.log("the user Id " + this.userId);
    // this.selectedCategory = localStorage.getItem("orderCategory") || "new";
    this.selectedCategory = "history";

    // if (this.$router.currentRoute.query.a === "sso") {
    if (GLOBAL_ENV_SDKTYPE === "sso") {
      let byUuid = true;
      this.getOrders(this.uuid, byUuid);
    } else {
      this.getOrders(this.userId);
    }

    // 有時候正確的回比較慢，會導致切換provider id變化時顯示錯誤
    this.subscription = authService.getUserId().subscribe((response) => {
      console.log('letter signin, subscribed event trigger ' + this.uuid);
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        let byUuid = true;
        let uuid = localStorage.getItem("qcsso:uuid");
        this.getOrders(uuid, byUuid);
      } else {
        this.getOrders(response.userId);
      }
    });

    // if (GLOBAL_TABS.indexOf("r") > -1) {
    //   this.showRetail = true;
    // }
  }
};
</script>
